// Globals (yay)
window._ = require("lodash")
window.Backbone = require("backbone")
window.React = require("react")
window.jQuery = window.$ = require("jquery")
window.moment = require("moment")
